import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/analytics-api.service';
import type { AnalyticsQueryParams } from '../types/analytics.types';

export const fpActionsKeys = {
  all: ['analytics', 'fp-actions'] as const,
  list: (params?: AnalyticsQueryParams) => [...fpActionsKeys.all, 'list', params] as const,
};

export const useFPActionsData = (params?: AnalyticsQueryParams, enabled = true) => {
  return useQuery({
    queryKey: fpActionsKeys.list(params),
    queryFn: async () => {
      const response = await analyticsApi.getFPActions(params);
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
    enabled,
  });
};
